import React from 'react';
import { Link } from 'react-router-dom';
import { preloadEngineeringPage } from '../routes/engineeringPage';
import wordmark from '../assets/recruit/jtcc-wordmark.svg';
import styles from './RecruitNavigation.module.css';

export function EngineeringTopCta() {
  return (
    <section className={styles.banner} aria-label="プロダクト専門職採用">
      <svg
        className={styles.bannerArt}
        viewBox="0 0 140 100"
        aria-hidden="true"
        fill="none"
      >
        {Array.from({ length: 32 }, (_, index) => (
          <g
            key={index}
            transform={`translate(70 50) scale(${0.8 + index * 0.009}) translate(-70 -50)`}
          >
            <path
              className={styles.strand}
              style={{ animationDelay: `-${index * 0.37}s` }}
              d="M36.2 1.5 1.4 39.8 60 98.6 98.3 60.2Z M80.3 1.4 64.5 13.9 106.2 55.6 118.6 39.8Z"
            />
          </g>
        ))}
      </svg>
      <div>
        <p className={styles.wordmark}>
          <img src={wordmark} alt="JTCC" />
          <span>Engineering</span>
        </p>
        <h2>楽しさを、技術でつくる。</h2>
        <span>プロダクト専門職採用</span>
      </div>
      <Link
        to="/recruit/engineering"
        onMouseEnter={preloadEngineeringPage}
        onFocus={preloadEngineeringPage}
        onPointerDown={preloadEngineeringPage}
      >
        プロダクト専門職の採用情報へ <span aria-hidden="true">↗</span>
      </Link>
    </section>
  );
}
